import { cn } from '@commenda/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const leadingTileVariants = cva(
  'flex size-9 shrink-0 items-center justify-center rounded-md border-1/2 border-border-secondary',
  {
    variants: {
      variant: {
        default: 'bg-bg-secondary',
        elevated: 'bg-bg-primary shadow-sm',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

export type SettingLeadingTileVariant = NonNullable<
  VariantProps<typeof leadingTileVariants>['variant']
>;

export interface SettingLeadingTileProps {
  variant?: SettingLeadingTileVariant;
  className?: string;
  children?: React.ReactNode;
}

export const SettingLeadingTile = ({
  variant = 'default',
  className,
  children,
}: SettingLeadingTileProps) => (
  <span className={cn(leadingTileVariants({ variant }), className)}>
    {children}
  </span>
);
